export default __webpack_public_path__ + "static/media/bg_completed.11ba7931.jpg";